module.exports = __webpack_public_path__ + "img/logo1 (36).75a0bc83.jpg";